import React, {useEffect, useState, useRef} from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import DeleteInsertBundleDialog from '../components/DeleteInsertBundleDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {sendDataToApi} from '../../../API/apiHelper';
import {styled} from '@mui/system';
import Cookies from 'js-cookie';
import EditInsertBundleDialog from '../components/EditInsertBundleDialog';

const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .negative.win_rate_per, .negative.revenue_per, .negative.fill_rate_per, .negative.profit_per': {
        backgroundColor: 'rgba(255,235,235)',
    },
    '& .positive.win_rate_per, .positive.revenue_per, .positive.fill_rate_per, .positive.profit_per': {
        backgroundColor: 'rgba(235,255,235)',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
    '& .total-row': {
        backgroundColor: 'lightgrey',
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-booleanCell[data-value="true"]': {
        color: 'rgb(58,187,58)',
    },
    '& .MuiDataGrid-booleanCell[data-value="false"]': {
        color: 'rgba(180,92,101,0.95)',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    return data.map(row => ({
        id: row.value.id,
        ...row.value,
    }));
}

const InsertBundlesPanelGrid = ({data, onRowEdit}) => {
    const gridRef = useRef(null);
    const [rows, setRows] = useState(processData(data));
    const [open, setOpen] = useState(false);
    const [openSend, setOpenSend] = useState(false);
    const [editRow, setEditRow] = useState({});
    const [openDelete, setOpenDelete] = useState(false);
    const [openEdit, setOpenEdit] = useState(false);

    const userAdmin = Cookies.get('user_admin');

    const has = field => rows.some(row => field in row);

    useEffect(() => {
        setRows(processData(data));
    }, [data]);


    const handleDeleteButtonClick = (row) => {
        setEditRow(row);
        setOpenDelete(true);
    };

    const handleDeleteClose = () => {
        setOpenDelete(false);
    };

    const handleRowDelete = (deletedRowId) => {
        setRows(rows.filter(row => row.id !== deletedRowId));
    };

    const handleEditClick = (row) => {
        console.log(row);
        setEditRow(row);
        setOpenEdit(true);
    };

    const handleCloseEdit = () => {
        setOpenEdit(false);
    };

    const handleCloseSend = () => {
        setOpenSend(false);
    };

    const openSendSuccess = () => {
        setOpenSend(true);
    };

    let columns = [
        {
            field: 'edit',
            headerName: '',
            width: 100,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    startIcon={<EditIcon/>}
                    color="primary"
                    size="medium"
                    onClick={() => handleEditClick(params.row)}
                    disabled={userAdmin !== '1'}
                >
                    Edit
                </Button>
            )
        },
        {
            field: 'delete',
            headerName: '',
            width: 130,
            renderCell: (params) => (
                <Button
                    variant="outlined"
                    startIcon={<DeleteIcon/>}
                    color="error"
                    size="medium"
                    onClick={() => handleDeleteButtonClick(params.row)}
                    disabled={userAdmin !== '1'}
                >
                    Delete
                </Button>
            )
        },
    ];
    if (has('id')) columns.push({ field: 'id', headerName: 'ID', width: 80 });
    if (has('bandle_name')) columns.push({ field: 'bandle_name', headerName: 'Bundle', width: 200 });
    if (has('type')) columns.push({ field: 'type', headerName: 'Type', width: 100 });
    if (has('adt_id')) columns.push({ field: 'adt_id', headerName: 'ADT Company ID', width: 150 });
    if (has('pushed_to_sh')) columns.push({ field: 'pushed_to_sh', headerName: 'Pushed to SH', width: 150, type: 'boolean' });
    if (has('added_at')) columns.push({ field: 'added_at', headerName: 'Added At', width: 180 });

    const handleSave = () => {
        const userId = localStorage.getItem('user_id');
        const updatedCompany = {
            ...editRow,
            ChangedBy: userId,
        };

        sendDataToApi('post', '/api/adtimizer/insert-bundles-panel/update', updatedCompany, false, (res) => {
            const updatedArray = rows.map(item =>
                item.id === editRow.id ? {...editRow} : item
            );
            setRows(updatedArray);
            setOpenEdit(false);
            openSendSuccess();
            onRowEdit();
        });
    };

    const handleInputChange = (event) => {
        const {name, value} = event.target;
        setEditRow({...editRow, [name]: value});
    };


    if (data.length === 0) {
        return null;
    } else {

        return (

            <div style={{height: 800, width: '100%'}} ref={gridRef}>
                <StyledDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={25}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    disableRowSelectionOnClick
                />

                <EditInsertBundleDialog
                    open={openEdit}
                    handleClose={handleCloseEdit}
                    data={editRow}
                    onChange={handleInputChange}
                    onSave={handleSave}
                />

                <DeleteInsertBundleDialog
                    open={openDelete}
                    handleClose={handleDeleteClose}
                    editRow={editRow}
                    onDeleteSuccess={handleRowDelete}
                />
            </div>
        );
    }
};

export default InsertBundlesPanelGrid;